import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Image, { FluidObject } from 'gatsby-image';
import styled from 'styled-components';
import {
  GetStartedQuery,
  MarkdownRemarkFrontmatterPlanList,
  MarkdownRemarkFrontmatterPlanListFeatureItems as FeatureItemsProps,
} from '../../types/graphql-types';
import { useTransformNode } from '../hooks/useTransformer';

const GetStartedOutterWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    overflow: hidden;
  }
`;

const GetStartedInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 97px;
  @media (max-width: 1000px) {
    width: 80%;
    padding-right: 10%;
    padding-left: 10%;
    margin-bottom: 48px;
  }
`;

const GetStartedHeaderWide = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  margin-top: 38px;
  margin-bottom: 35px;
  @media (max-width: 1000px) {
    margin-top: 26px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const GetStartedHeaderNarrow = styled.div`
  display: none;
  flex-direction: column;
  width: 375px;
  height: 80px;
  margin-top: 45px;
  margin-bottom: 46px;
  @media (max-width: 768px) {
    display: flex;
  }
`;

const GetStartedMainSentence = styled.div`
  font-size: 37px;
  font-weight: 300;
  color: #000000;
  text-align: center;
  letter-spacing: -0.25px;
  @media (max-width: 768px) {
    font-size: 36px;
    letter-spacing: -0.24px;
  }
`;

const MainContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

const PlanWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
`;

const PlanHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: left;
  padding-top: 24px;
`;

const PlanHeaderImageStyle = styled.div`
  width: 30px;
  height: 30px;
  margin-right: 13px;
`;

const PlanHeader = styled.div`
  height: 34px;
  font-size: 20px;
  font-weight: bold;
  color: #3c3c3c;
  text-align: left;
  letter-spacing: -0.13px;
`;

const LabelWrapper = styled.div`
  justify-content: center;
  padding-bottom: 15px;
  @media (max-width: 1000px) {
    justify-content: center;
    padding-bottom: 35px;
  }
`;

const PlanLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  margin-left: 2px;
  font-size: 16px;
  font-weight: 500;
  background: #ffe357;
  border-radius: 15.5px;
`;

const EmptyLabel = styled.div``;

const PlanContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding-bottom: 57px;
  @media (max-width: 768px) {
    padding-bottom: 36px;
  }
`;

const PlanSentence = styled.div`
  position: ablolute;
`;

const PlanPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 126px;
  margin-top: -8px;
  @media (max-width: 1000px) {
    padding-bottom: 3px;
  }
`;

const PlanPrice = styled.div`
  height: 126px;
  margin-right: 19px;
  font-size: 76px;
  font-weight: 500;
  color: #3c3c3c;
  letter-spacing: -0.51px;
`;

const PlanPriceUnit = styled.div`
  margin-top: 60px;
  font-size: 24px;
  font-weight: 500;
`;

const PlanIncludeMember = styled.div`
  height: 34px;
  margin-top: -21px;
  margin-bottom: 27px;
  margin-left: 3px;
  font-size: 24px;
  font-weight: 300;
  line-height: 34px;
  color: #3c3c3c;
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

const PlanAddMember = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  height: 72px;
`;

const PlanAddMemberSentence = styled.div`
  height: 36px;
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  color: #3c3c3c;
  letter-spacing: -0.16px;
`;

const PlanAddmemberCostWrapper = styled.div`
  display: flex;
  height: 36px;
`;

const PlanAddmemberCost = styled.div`
  padding-right: 5px;
  font-size: 36px;
  font-weight: 400;
  line-height: 36px;
  color: #3c3c3c;
`;

const PlanAddMemberUnit = styled.div`
  margin-top: 7px;
  font-size: 24px;
  font-weight: 300;
  line-height: 24px;
  color: #3c3c3c;
`;

const MemberImageStyle = styled.div`
  width: 257px;
  height: 222px;
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 37px;
  right: 7%;
  @media (max-width: 1000px) {
    right: 0px;
  }
`;

const PersonImageStyle = styled.div`
  width: 195px;
  height: 222px;
`;

const FeatureImageStyle = styled.div`
  width: 20px;
  height: 20px;
`;

const FeatureImageWrapper = styled.div`
  display: flex;
  margin-top: 2px;
  margin-right: 12px;
  margin-left: 5px;
`;

const FeatureNonImage = styled.div`
  width: 20px;
  height: 20px;
`;

const FeatureItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: left;
  line-height: 1em;
`;

const FeatureText = styled.div`
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
  color: #000000;
  letter-spacing: -0.01px;
`;

const FeatureGrayoutText = styled(FeatureText)`
  color: #999999;
`;

const FeatureItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding-bottom: 16px;
`;

const FeatureListGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(5, 1fr);
  grid-auto-flow: column;
  grid-column-gap: 2%;
  justify-content: left;
  @media (max-width: 768px) {
    grid-auto-flow: row;
  }
`;

const PlanListGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-template-columns: 50% 50%;
  grid-auto-flow: column;
  justify-content: center;
  width: 100%;
  > :nth-child(n) {
    padding-right: 5%;
    padding-left: 5%;
  }
  > :nth-child(2) {
    border-right: 6px dotted #28bafd;
  }
  @media (max-width: 1000px) {
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    width: 100%;
    > :nth-child(n) {
      max-width: 80%;
      padding-right: 10%;
      padding-left: 10%;
      border-right: none;
    }
    > :nth-child(2) {
      padding-bottom: 28px;
      border-bottom: 6px dotted #28bafd;
    }
    > :nth-child(3) {
      padding-top: 43px;
    }
  }
  @media (max-width: 768px) {
    > :nth-child(2) {
      padding-bottom: 34px;
    }
    > :nth-child(3) {
      padding-top: 49px;
    }
  }
`;

const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 60px;
`;

const PlanButton = styled.a`
  padding: 14px 42px;
  font-size: 20px;
  font-weight: 200;
  color: #fff;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0px;
  cursor: pointer;
  background-color: #28bafd;
  border-radius: 3px;
`;

const SpecialPricingText = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
`;

const SpecialPricingEmail = styled.a`
  margin-left: 5px;
  font-size: 16px;
  font-weight: 200;
  line-height: 1.7;
  color: #28bafd;
  text-decoration: none;
`;

const SpecialPricingDiv = styled.div`
  margin-bottom: 20px;
  @media (max-width: 768px) {
    padding: 0 30px;
  }
`;

type PlanListProps = Pick<
  MarkdownRemarkFrontmatterPlanList,
  'labelName' | 'planHeader' | 'price' | 'featureItems'
>;

const GET_STARTED_QUERY = graphql`
  query GetStarted {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "get-started" } } }
    ) {
      edges {
        node {
          id
          fields {
            language
            country
          }
          frontmatter {
            templateKey
            getStartedHeader {
              firstSentence
              secondSentence
            }
            planList {
              labelName
              planHeader {
                text
                value
                img {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              price {
                priceSentence {
                  price
                  unit
                  includeMembers
                  addMembers {
                    sentence
                    cost
                    unit
                  }
                }
                memberImg {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              featureItems {
                feature
                img {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
            allPlanButton {
              name
              path
            }
            specialPricingText
            specialPricingEmail {
              url
              text
            }
          }
        }
      }
    }
  }
`;

const PlanHeaderImage = PlanHeaderImageStyle.withComponent(Image);
const MemberImage = MemberImageStyle.withComponent(Image);
const FeatureImage = FeatureImageStyle.withComponent(Image);
const PersonImage = PersonImageStyle.withComponent(Image);

const featureListTable = (featureItems: FeatureItemsProps[]) => {
  return featureItems.map((list, i) => {
    return (
      <FeatureItem key={i}>
        {list.img ? (
          <>
            <FeatureImageWrapper>
              <FeatureImage
                alt="check image"
                fluid={list.img.childImageSharp?.fluid as FluidObject}
                imgStyle={{ objectFit: 'contain' }}
              />
            </FeatureImageWrapper>
            <FeatureText>{list.feature}</FeatureText>
          </>
        ) : (
          <>
            <FeatureImageWrapper>
              <FeatureNonImage />
            </FeatureImageWrapper>
            <FeatureGrayoutText>{list.feature}</FeatureGrayoutText>
          </>
        )}
      </FeatureItem>
    );
  });
};

const planListTable = (content: PlanListProps[]) => {
  return React.Children.toArray(
    content.map((plan) => {
      return (
        <>
          {plan.labelName ? (
            <LabelWrapper>
              <PlanLabel>{plan.labelName}</PlanLabel>
            </LabelWrapper>
          ) : (
            <EmptyLabel></EmptyLabel>
          )}
          <PlanWrapper>
            <PlanHeaderWrapper>
              {plan.labelName ? (
                <PlanHeaderImage
                  alt="star image"
                  fluid={
                    plan.planHeader?.img?.childImageSharp?.fluid as FluidObject
                  }
                  imgStyle={{ objectFit: 'contain' }}
                />
              ) : (
                <></>
              )}
              <PlanHeader>{plan.planHeader?.text}</PlanHeader>
            </PlanHeaderWrapper>
            <PlanContentWrapper>
              <PlanSentence>
                <PlanPriceWrapper>
                  <PlanPrice>{plan.price?.priceSentence?.price}</PlanPrice>
                  <PlanPriceUnit>
                    {plan.price?.priceSentence?.unit}
                  </PlanPriceUnit>
                </PlanPriceWrapper>
                <PlanIncludeMember>
                  {plan.price?.priceSentence?.includeMembers}
                </PlanIncludeMember>
                <PlanAddMember>
                  {plan.price?.priceSentence?.addMembers?.cost ? (
                    <>
                      <PlanAddMemberSentence>
                        {plan.price.priceSentence.addMembers.sentence}
                      </PlanAddMemberSentence>
                      <PlanAddmemberCostWrapper>
                        <PlanAddmemberCost>
                          {plan.price.priceSentence.addMembers.cost}
                        </PlanAddmemberCost>
                        <PlanAddMemberUnit>
                          {plan.price.priceSentence.addMembers.unit}
                        </PlanAddMemberUnit>
                      </PlanAddmemberCostWrapper>
                    </>
                  ) : (
                    <>
                      <PlanAddMemberSentence>
                        {plan.price?.priceSentence?.addMembers?.sentence}
                      </PlanAddMemberSentence>
                    </>
                  )}
                </PlanAddMember>
              </PlanSentence>
              <ImageWrapper>
                {plan.planHeader?.value === 'entry' ? (
                  <PersonImage
                    alt="Person image"
                    fluid={
                      plan.price?.memberImg?.childImageSharp
                        ?.fluid as FluidObject
                    }
                    imgStyle={{ objectFit: 'contain' }}
                  />
                ) : (
                  <MemberImage
                    alt="Member image"
                    fluid={
                      plan.price?.memberImg?.childImageSharp
                        ?.fluid as FluidObject
                    }
                    imgStyle={{ objectFit: 'contain' }}
                  />
                )}
              </ImageWrapper>
            </PlanContentWrapper>
            <FeatureItemsWrapper>
              <FeatureListGrid>
                {featureListTable(plan.featureItems as FeatureItemsProps[])}
              </FeatureListGrid>
            </FeatureItemsWrapper>
          </PlanWrapper>
        </>
      );
    }),
  );
};

const GetStarted: React.FC = () => {
  const data = useStaticQuery<GetStartedQuery>(GET_STARTED_QUERY);
  const { frontmatter } = useTransformNode(data);

  return (
    <GetStartedOutterWrapper>
      <GetStartedInnerWrapper>
        <GetStartedHeaderWide>
          <GetStartedMainSentence>
            {`${[
              frontmatter?.getStartedHeader?.firstSentence,
              frontmatter?.getStartedHeader?.secondSentence,
            ]
              .filter(Boolean)
              .join(' ')}`}
          </GetStartedMainSentence>
        </GetStartedHeaderWide>
        <GetStartedHeaderNarrow>
          <GetStartedMainSentence>
            {frontmatter?.getStartedHeader?.firstSentence}
          </GetStartedMainSentence>
          <GetStartedMainSentence>
            {frontmatter?.getStartedHeader?.secondSentence}
          </GetStartedMainSentence>
        </GetStartedHeaderNarrow>
        <MainContentWrapper>
          <PlanListGrid>
            {planListTable(frontmatter?.planList as PlanListProps[])}
          </PlanListGrid>
        </MainContentWrapper>
        <ButtonDiv>
          <PlanButton
            href={frontmatter?.allPlanButton?.path ?? ''}
            data-cy="buttonPlan"
            id="button-plan"
          >
            {frontmatter?.allPlanButton?.name}
          </PlanButton>
        </ButtonDiv>
        <SpecialPricingDiv>
          <SpecialPricingText>
            {frontmatter?.specialPricingText}
            <SpecialPricingEmail
              href={frontmatter?.specialPricingEmail?.url ?? ''}
            >
              {frontmatter?.specialPricingEmail?.text}
            </SpecialPricingEmail>
          </SpecialPricingText>
        </SpecialPricingDiv>
      </GetStartedInnerWrapper>
    </GetStartedOutterWrapper>
  );
};

export default GetStarted;
